export const SIGNUP_FLOW_MARKETPLACE = 'marketplaceSignup';
export const SIGNUP_FLOW_PARTNER_ONBOARDING = 'partnerApplicationSignup';
